import { CMS, GetFaqResponse } from "types/cms";
import { END_POINTS } from "../helpers";
import { CommonBody, FaqRes } from "../types/General";
import { User } from "../types/User";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  statusCode: number;
  data?: User;
  message: string;
};

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

type GetCmsResponse = {
  _id: string;
  email: string;
  phone: string;
  terms: string;
  privacyPolicy: string;
  aboutUs: string;
  dialCode: string;
};

export type GetSettingResponse = {
  inspectionFee: number;
  postingFee: number;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  id: string;
};

export const faqApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCms: builder.query<CommonResponse & { data: CMS }, {}>({
      query: () => ({
        url: END_POINTS.cms,
        method: "GET",
      }),
    }),
    updateCms: builder.mutation<CommonResponseType & { data: CMS }, CommonBody>(
      {
        query: (body) => ({
          url: `${END_POINTS.cms}`,
          method: "PUT",
          body,
        }),
      }
    ),
    getFAQ: builder.query<
      CommonResponseType & { data: GetFaqResponse },
      {
        search: string;
        page: number;
      }
    >({
      query: ({ search, page }) => ({
        url: `${END_POINTS.faq}?page=${page}&search=${search}`,
        method: "GET",
      }),
    }),
    addFAQ: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.faq,
        method: "POST",
        body,
      }),
    }),
    updateFaq: builder.mutation<
      CommonResponseType & { data: FaqRes },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.faq}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteFaq: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.faq}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetCmsQuery,

  useUpdateCmsMutation,
  useLazyGetFAQQuery,
  useAddFAQMutation,
  useUpdateFaqMutation,
  useLazyDeleteFaqQuery,
} = faqApi;
